"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateNotificacao = exports.update = exports.create = exports.findOne = exports.findAllClienteLogado = exports.findAllMatriculasAtivas = exports.findAll = void 0;
const core_1 = require("./core");
function findAll(page = 1, search) {
    return core_1.get('Matricula', 'lista', Object.assign({ pg: page }, search))
        .then(({ dados, paginacao }) => {
        if (dados.length === 0)
            return {
                elements: [],
                elementsPerPage: 0,
                totalElements: 0,
                currentPage: 0,
                totalPages: 0
            };
        return {
            elements: dados,
            elementsPerPage: paginacao.totalRegPorPagina,
            totalElements: paginacao.totalRegEncontrados,
            currentPage: paginacao.pagAtual,
            totalPages: paginacao.qtdPag
        };
    });
}
exports.findAll = findAll;
function findAllMatriculasAtivas(page = 1, search) {
    return core_1.get('Matricula', 'listaMatriculasAtivas', Object.assign({ pg: page }, search))
        .then(({ dados, paginacao }) => {
        if (dados.length === 0)
            return {
                elements: [],
                elementsPerPage: 0,
                totalElements: 0,
                currentPage: 0,
                totalPages: 0
            };
        return {
            elements: dados,
            elementsPerPage: paginacao.totalRegPorPagina,
            totalElements: paginacao.totalRegEncontrados,
            currentPage: paginacao.pagAtual,
            totalPages: paginacao.qtdPag
        };
    });
}
exports.findAllMatriculasAtivas = findAllMatriculasAtivas;
function findAllClienteLogado(page = 1, search) {
    return core_1.get('Matricula', 'listaMatriculaClienteLogado', Object.assign({ pg: page }, search))
        .then(({ dados, paginacao }) => {
        if (dados.length === 0)
            return {
                elements: [],
                elementsPerPage: 0,
                totalElements: 0,
                currentPage: 0,
                totalPages: 0
            };
        return {
            elements: dados,
            elementsPerPage: paginacao.totalRegPorPagina,
            totalElements: paginacao.totalRegEncontrados,
            currentPage: paginacao.pagAtual,
            totalPages: paginacao.qtdPag
        };
    });
}
exports.findAllClienteLogado = findAllClienteLogado;
function findOne(id) {
    return core_1.get('Matricula', 'detalhe', { id });
}
exports.findOne = findOne;
function create(data) {
    return core_1.post('Matricula', 'cadastro', data);
}
exports.create = create;
function update(id, data) {
    return core_1.put('Matricula', 'update', Object.assign({ id }, data));
}
exports.update = update;
function updateNotificacao(id, descNotificacoes) {
    return core_1.put('Matricula', 'updateNotificacao', {
        id,
        descNotificacoes
    });
}
exports.updateNotificacao = updateNotificacao;
